<template>
  <div class="filter-bar clear">
    <div class="filter-list" ref="filterlist">
      <slot></slot>
    </div>
    <ul class="btn-list">
      <li class="search"><uButton @click="search">搜索</uButton></li>
      <li class="reset coat-10" @click="reset">重置</li>
      <li class="show coat-10" @click="togger" ref="folded"> {{folded}}</li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: "filterBar",
    data() {
      return {
        itemLenght: 0
      }
    },
    props: {
     onSearch: {
      type: Function,
      default() {},
    },
    onReset: {
      type: Function,
      default() {},
    },
  },
  data() {
    return {
      folded: "展开"
    };
  },
  methods: {
    search(){
      this.onSearch()
    },
    reset(){
      this.onReset()

    },
    togger() {
      let f = this.$refs.folded;
      this.toggleClass(this.$refs.folded, "folded");
      let fd = this.hasClass(this.$refs.folded, "folded");
      if (fd) {
        this.folded = "收起";
        let els = this.$refs.filterlist.children;
        for (let i = 0; i < els.length; i++) {
          if (els[i].className.indexOf("hidden") !== -1) {
            els[i].setAttribute("style", "display:inline-block");
          }
        }
      } else {
        this.folded = "展开";
        let els = this.$refs.filterlist.children;
        for (let i = 0; i < els.length; i++) {
          if (els[i].className.indexOf("hidden") !== -1) {
            els[i].setAttribute("style", "display:none");
          }
        }
      }
    },
    hasClass(elem, cls) {
      cls = cls || "";
      if (cls.replace(/\s/g, "").length == 0) return false; //当cls没有参数时，返回false
      return new RegExp(" " + cls + " ").test(" " + elem.className + " ");
    },
    addClass(obj, cls) {
      if (!this.hasClass(obj, cls)) obj.className += " " + cls;
    },
    removeClass(obj, cls) {
      if (this.hasClass(obj, cls)) {
        var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
        obj.className = obj.className.replace(reg, " ");
      }
    },
    toggleClass(obj, cls) {
      if (this.hasClass(obj, cls)) {
        this.removeClass(obj, cls);
      } else {
        this.addClass(obj, cls);
      }
    }
  },
  mounted: function() {
    let els = this.$refs.filterlist.children;
    for (let i = 0; i < els.length; i++) {
      if (i > 2) {
        els[i].className += " hidden";
      }
    }
    if(els.length <4){

      this.$refs.folded.setAttribute("style", "display:none");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/filterBar/filterBar.vue